import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/feature/customers/feature-customers.service.ts
 * (internal to FeatureService; injected directly as an Angular 18 class).
 *
 * The uiRouter / 'ui.bootstrap' / customers-order controller module deps are
 * preserved for module-graph parity (prompt()'s `$state.go` + `$uibModal.open`
 * resolve those at runtime).
 */
export { FeatureCustomersService } from '@ng/core/feature/customers/feature-customers.service';

export const FeatureCustomersServiceModule = angular.module('acme.common.service.feature.customers', [
  uiRouter,
  'ui.bootstrap',
  'acme.view.application.customers.modals.order.controllers',
]).name;
